const headerData = [{
		types: "selection",
		columnwidth: 50,
	}, {
		prop: "id",
		label: "序号",
		columnwidth: 50,
	},
	{
		prop: "Year",
		label: "年份",
		columnwidth: 60,
	},
	{
		prop: "InvClassName",
		label: "产品线",
		columnwidth: 100,
	},
	{
		prop: "LEVEL3",
		label: "Level3",
		columnwidth: 140,
	},
	{
		prop: "AreaManName",
		label: "小区经理",
		columnwidth: 140,
	},
	{
		prop: "MoneyQuota",
		label: "年度金额BP",
		columnwidth: 120,
	},
	{
		prop: "CreatorName",
		label: "创建人",
		columnwidth: 130,
	},
	{
		prop: "CreateTime",
		label: "创建时间",
		columnwidth: 110,
	},
	{
		prop: "UpdaterName",
		label: "修改人",
		columnwidth: 120,
	},
	{
		prop: "UpdateTime",
		label: "修改时间",
		columnwidth: 110,
	}
];
export default headerData;